import React, { useEffect, useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import { URLS } from "../../Services/Constant";
import { get, post } from "../../Services/ApiHandler";
import { toast } from "react-toastify";
import { checkPermission } from "../redux/api/PermissionManager";

function WhatsappDetails() {
  const [isValue, setIsValue] = useState({
    appwhatsappNo: "",
    appdescription: "",
    appid: "",
    appcheck: false,
    landing_whatsappNo: "",
    landing_description: "",
    landing_id: "",
    landingcheck: false,
    aisupport: "",
    aidescription: "",
    aiId: "",
    aicheck: false,
  });

  const [isEditApp, setIsEditApp] = useState(false);
  const [isEditAi, setIsEditAi] = useState(false);
  const [isEditLanding, setIsEditLanding] = useState(false);

  const fetchData = async () => {
    const url = `${URLS.MASTERURL}by-ids?ids=35,41,49`;
    try {
      const res = await get(url);
      const data = res?.data || [];
      console.log("data**********", data);
      const appData = data.find((item) => item.type === 35);
      const landingData = data.find((item) => item.type === 41);
      const aiData = data.find((item) => item.type === 49);

      setIsValue((prev) => ({
        ...prev,
        appwhatsappNo: appData?.name || "",
        appdescription: appData?.icon || "",
        appid: appData?.id || "",
        appcheck: !!appData?.status,

        landing_whatsappNo: landingData?.name || "",
        landing_description: landingData?.icon || "",
        landing_id: landingData?.id || "",
        landingcheck: !!landingData?.status,

        aisupport: aiData?.name || "",
        aidescription: aiData?.icon || "",
        aiId: aiData?.id || "",
        aicheck: !!aiData?.status,
      }));
    } catch (err) {
      console.log("err", err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setIsValue((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdateApp = async () => {
    try {
      const formdata = new FormData();
      formdata.append("name", isValue.appwhatsappNo);
      formdata.append("icon", isValue.appdescription);
      formdata.append("type", 35);
      formdata.append("status", isValue.appcheck ? 1 : 0);
      const res = await post(
        `${URLS.WHATSAPPSUPPORT}${isValue.appid}/edit/`,
        formdata,
      );
      if (res?.status === "success") {
        toast.success(res?.message || "App WhatsApp updated");
        setIsEditApp(false);
      }
    } catch (err) {
      console.log("Error updating app:", err);
    }
  };

  const handleUpdateAiSupport = async () => {
    try {
      const formdata = new FormData();
      formdata.append("name", isValue.aisupport);
      formdata.append("icon", isValue.aidescription);
      formdata.append("type", 49);
      formdata.append("status", isValue.aicheck ? 1 : 0);
      const res = await post(
        `${URLS.WHATSAPPSUPPORT}${isValue.aiId}/edit/`,
        formdata,
      );
      if (res?.status === "success") {
        toast.success(res?.message || "Ai Support updated");
        setIsEditAi(false);
      }
    } catch (err) {
      console.log("Error updating app:", err);
    }
  };

  const handleUpdateLanding = async () => {
    try {
      const formdata = new FormData();
      formdata.append("name", isValue.landing_whatsappNo);
      formdata.append("icon", isValue.landing_description);
      formdata.append("type", 41);
      formdata.append("status", isValue.landingcheck ? 1 : 0);
      const res = await post(
        `${URLS.WHATSAPPSUPPORT}${isValue.landing_id}/edit/`,
        formdata,
      );
      if (res?.status === "success") {
        toast.success(res?.message || "Landing WhatsApp updated");
        setIsEditLanding(false);
      }
    } catch (err) {
      console.log("Error updating landing:", err);
    }
  };

  return (
    <>
      <Topbar header={"Settings"} subHead={"What'sApp"} />

      {/* Vow App Section */}
      <div className="row mb-4">
        <div>
          <p style={{ fontSize: 24, fontWeight: 600, color: "darkBlue" }}>
            Vow App
          </p>
        </div>
        <div className="col-md-5">
          <div>
            <div style={{ display: "flex", gap: 10 }}>
              <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                Whatsapp Number <span style={{ color: "red" }}>*</span>&nbsp;
              </label>
              <input
                type="checkbox"
                checked={isValue?.appcheck}
                onChange={(e) =>
                  handleChange({
                    target: { name: "appcheck", value: e.target.checked },
                  })
                }
                disabled={!isEditApp}
              />
            </div>

            <input
              className="input-box"
              name="appwhatsappNo"
              value={isValue.appwhatsappNo}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "");
                if (value.length <= 10) {
                  handleChange({ target: { name: "appwhatsappNo", value } });
                }
              }}
              inputMode="numeric"
              maxLength={10}
              placeholder="Number"
              disabled={!isEditApp}
            />
            <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1 mt-4">
              Description
            </label>
            <textarea
              className="input-box"
              name="appdescription"
              value={isValue.appdescription}
              onChange={(e) =>
                handleChange({
                  target: { name: "appdescription", value: e.target.value },
                })
              }
              disabled={!isEditApp}
            />
            {isEditApp && (
              <button
                onClick={handleUpdateApp}
                className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn mt-3"
              >
                Update
              </button>
            )}
          </div>
        </div>
        {checkPermission("CAN-EDIT-SUPPORT_NUMBER") && !isEditApp && (
          <div className="col-md-5">
            <button
              onClick={() => setIsEditApp(true)}
              className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn"
            >
              Edit
            </button>
          </div>
        )}
      </div>
      <hr />

      {/* vow ai support  */}

      <div className="row mb-4">
        <div>
          <p style={{ fontSize: 24, fontWeight: 600, color: "darkBlue" }}>
            Vow AI Support
          </p>
        </div>
        <div className="col-md-5">
          <div>
            <div style={{ display: "flex", gap: 10 }}>
              <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                Support Number <span style={{ color: "red" }}>*</span>&nbsp;
              </label>
              <input
                type="checkbox"
                checked={isValue?.aicheck}
                onChange={(e) =>
                  handleChange({
                    target: { name: "aicheck", value: e.target.checked },
                  })
                }
                disabled={!isEditAi}
              />
            </div>

            <input
              className="input-box"
              name="aisupport"
              value={isValue.aisupport}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "");
                if (value.length <= 10) {
                  handleChange({ target: { name: "aisupport", value } });
                }
              }}
              inputMode="numeric"
              maxLength={10}
              placeholder="Number"
              disabled={!isEditAi}
            />
            <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1 mt-4">
              Description
            </label>
            <textarea
              className="input-box"
              name="aidescription"
              value={isValue.aidescription}
              onChange={(e) =>
                handleChange({
                  target: { name: "aidescription", value: e.target.value },
                })
              }
              disabled={!isEditAi}
            />
            {isEditAi && (
              <button
                onClick={handleUpdateAiSupport}
                className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn mt-3"
              >
                Update
              </button>
            )}
          </div>
        </div>
        {checkPermission("CAN-EDIT-SUPPORT_NUMBER") && !isEditAi && (
          <div className="col-md-5">
            <button
              onClick={() => setIsEditAi(true)}
              className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn"
            >
              Edit
            </button>
          </div>
        )}
      </div>

      {/* Vow Landing Section */}
      <hr />
      <div className="row mt-4">
        <div>
          <p style={{ fontSize: 24, fontWeight: 600, color: "darkBlue" }}>
            Vow Landing
          </p>
        </div>
        <div className="col-md-5 pt-2">
          <div>
            <div style={{ display: "flex", gap: 10 }}>
              <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                Whatsapp Number <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="checkbox"
                checked={isValue?.landingcheck}
                onChange={(e) =>
                  handleChange({
                    target: { name: "landingcheck", value: e.target.checked },
                  })
                }
                disabled={!isEditLanding}
              />
            </div>

            <input
              className="input-box"
              name="landing_whatsappNo"
              value={isValue.landing_whatsappNo}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "");
                if (value.length <= 10) {
                  handleChange({
                    target: { name: "landing_whatsappNo", value },
                  });
                }
              }}
              inputMode="numeric"
              maxLength={10}
              placeholder="Number"
              disabled={!isEditLanding}
            />
            <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1 mt-4">
              Description
            </label>
            <textarea
              className="input-box"
              name="landing_description"
              value={isValue.landing_description}
              onChange={(e) =>
                handleChange({
                  target: {
                    name: "landing_description",
                    value: e.target.value,
                  },
                })
              }
              disabled={!isEditLanding}
            />
            {isEditLanding && (
              <button
                onClick={handleUpdateLanding}
                className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn mt-3"
              >
                Update
              </button>
            )}
          </div>
        </div>
        {checkPermission("CAN-EDIT-SUPPORT_NUMBER") && !isEditLanding && (
          <div className="col-md-5">
            <button
              onClick={() => setIsEditLanding(true)}
              className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn"
            >
              Edit
            </button>
          </div>
        )}
      </div>
    </>
  );
}

export default WhatsappDetails;
